import classNames from "classnames"
import React from "react"

import { Color } from "../../../../constants/V2/color"
import { getBorderColorClass } from "../../../../utils/V2/color"
import TextButton from "../../../elements/V2/Buttons/TextButton"

type ScrollLinksBannerItemProps = {
  title: string
  anchorId: string
  isSelected: boolean
  textColor: Color
}

export const ScrollLinksBannerItem = ({
  anchorId,
  title,
  isSelected,
  textColor,
}: ScrollLinksBannerItemProps) => {
  return (
    <div className="relative">
      <TextButton
        weight="medium"
        color={textColor}
        textSize="body-md"
        text={title}
        style="none"
        linkUrl={`#${anchorId}`}
        scrollOffset={100}
        className={classNames(
          "mt-24 cursor-pointer whitespace-nowrap hover:opacity-100",
          {
            [getBorderColorClass(textColor)]: isSelected,
            "opacity-50": !isSelected,
            "border-transparent": !isSelected,
          }
        )}
      />

      <div
        className={classNames(
          "mt-20 h-[2px] w-full bg-blue transition-opacity duration-200 sm:h-[3px]",
          isSelected ? "opacity-100 delay-100" : "opacity-0"
        )}
      />
    </div>
  )
}
